export default {
  apiUrl: process.env.VUE_APP_API_URL,
  pusherUrl: process.env.VUE_APP_PUSHER_URL,
  pusherPort: process.env.VUE_APP_PUSHER_PORT,
  pusherKey: process.env.VUE_APP_PUSHER_KEY,
  devtool: 'source-map',
};
